{{#if e_sign_class}}
  <div class="e-sign-wrapper {{e_sign_class}}">
{{/if}}
{{#if name_required}}
  <label
  class="e-sign-resource-name-label"
  for="e-sign-resource-{{id}}-name">{{t 'Enter your name'}}</label>
  <input
    type="text"
    class="e-sign-resource-name-input"
    id="e-sign-resource-{{id}}-name"
    {{#if signed}}
    value="{{signed_name}}" disabled="true"
    {{else}}
    {{#if requires_link_click}}disabled="true"{{/if}}
    {{/if}}
    />
{{/if}}
{{#if e_sign_caption_signed}}
  <input type="checkbox" id="e-sign-resource-{{id}}" class="e-sign-checkbox"
  {{#if signed}}
    checked="checked" disabled="disabled"/>
    <label for="e-sign-resource-{{id}}" class="e-sign-label">
      <span class="{{e_sign_caption_class}}">{{t e_sign_caption_signed}}</span>
    </label>
  {{else}}
    {{#if requires_link_click}}disabled="disabled"{{/if}}/>
    <label for="e-sign-resource-{{id}}" tabindex="0" class="e-sign-label">
      <span class="{{e_sign_caption_class}}">{{t e_sign_caption}}</span>
    </label>
  {{/if}}
{{else}}
  <input type="checkbox" id="e-sign-resource-{{id}}" class="e-sign-checkbox"
    {{#if signed}}
      checked="checked" disabled="disabled"
    {{else}}
      {{#compare requires_link_click '||' name_required}}disabled="disabled"{{/compare}}
    {{/if}}/>
  <label for="e-sign-resource-{{id}}" class="e-sign-label">
    <span class="{{e_sign_caption_class}}">{{t e_sign_caption}}</span>
  </label>
{{/if}}

{{#if e_sign_class}}
  </div>
{{/if}}
